import { makeStyles } from '@material-ui/core/styles';
import { Bogle_Regular } from 'constants/constant';
import { colors } from 'theme/color-palette';

const { WHITE, LIGHTER_BLACK, TOGGLE_ACTIVE, LIGHT_GRAY_SHADE, GREY } = colors;
const FONT_SIZE_12PX = '12px';

const useStyles = makeStyles(() => ({
	/* Widget Container Styles*/
	vhWidgetContainer: {
		zIndex: 100,
		top: '290px',
		right: '16px',
		width: '414px',
		position: 'fixed',
		background: WHITE,
		borderRadius: '8px',
		boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.2)',
		fontFamily: Bogle_Regular
	},

	vhWidgetBody: {
		display: 'flex',
		height: '300px'
	},
	vhWidgetBodyNoResults: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: '300px'
	},
	noResultsTitle: {
		color: '#74767C',
		fontWeight: '700',
		margin: 0
	},
	noResultsDescription: {
		color: '#74767C',
		margin: 0
	},

	/* Search Field Styles */
	search: {
		position: 'relative',
		borderRadius: '6px',
		color: 'grey',
		margin: '12px',
		paddingLeft: '30px',
		background: '#FFFFFF',
		border: `2px solid #d4d4d4`,
		display: 'flex',
		justifyContent: 'Space_Between'
	},
	searchIcon: {
		padding: '4px',
		height: '100%',
		color: GREY,
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		top: '-4px',
		left: '6px',
		justifyContent: 'center',
		'& .MuiSvgIcon-root': {
			width: '18px'
		}
	},
	searchInput: {
		fontFamily: Bogle_Regular,
		width: '100%',
		fontWeight: 400,
		fontSize: '12px',
		height: 'auto',
		'& input': {
			paddingTop: '12px'
		}
	},
	crossIcon: {
		color: GREY,
		display: 'flex',
		alignItems: 'center',
		marginRight: '12px',
		'& .MuiSvgIcon-root': {
			width: '18px'
		}
	},

	/* Left Panel Styles - Widget & Filter */
	vhWidgetLeftPanel: {
		width: '180px',
		display: 'flex',
		flexDirection: 'column',
		'& ul': {
			paddingTop: '16px'
		},
		'& li': {
			width: '175px'
		}
	},
	leftPanelOptions: {
		height: '276px',
		overflowY: 'scroll',
		overflowX: 'hidden'
	},

	menuListContainterLeft: {
		padding: '0px !important'
	},
	menuItemLeft: {
		display: 'flex',
		maxHeight: '32px !important',
		minHeight: '32px !important',
		padding: '0px 0px 0px 12px',
		overflow: 'hidden'
	},
	menuItemLeftSelected: {
		display: 'flex',
		maxHeight: '32px !important',
		minHeight: '32px !important',
		backgroundColor: TOGGLE_ACTIVE,
		// overflow: 'visible',
		'&:hover': {
			backgroundColor: '#DFDCE7'
		}
	},
	leftPanelText: {
		'& span': {
			fontSize: FONT_SIZE_12PX,
			alignItems: 'center',
			paddingTop: '4px',
			fontWeight: 400
		}
	},
	accordionItemsContainer: {
		width: '100%',
		margin: '0px',
		paddingRight: '0px',

		'& .MuiButtonBase-root': {
			justifyContent: 'flex-start'
		},
		'& .MuiAccordionSummary-root': {
			minHeight: '32px',
			padding: '0px 0px',
			height: '32px'
		}
	},
	accordionSummary: {
		'& .MuiAccordionSummary-content': {
			margin: '0px'
		}
	},
	accordionSummaryItem: {
		height: '32px',
		minHeight: '32px !important',
		padding: '0px 12px'
	},
	accordionSummaryItemContainer: {
		display: 'flex',
		alignItems: 'center'
	},
	accordionSummaryText: {
		fontWeight: 400,
		margin: 0,
		'& span': {
			fontSize: FONT_SIZE_12PX,
			textWrap: 'nowrap',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: '150px'
		}
	},
	accordionDetailsItem: {
		height: '32px',
		minHeight: '32px !important'
		// paddingLeft: '20px'
	},
	accordionDetailsText: {
		fontWeight: 400,
		margin: 0,
		width: '140px',
		'& span': {
			fontSize: FONT_SIZE_12PX,
			paddingLeft: '20px',
			textWrap: 'nowrap',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden'
		}
	},

	/*Widget Right Panel - Element Styles/ Classes*/
	vhWidgetRightPanel: {
		width: '233px',
		display: 'flex',
		flexDirection: 'column'
	},
	rightPanelOptions: {
		height: '276px',
		overflowY: 'scroll'
	},
	subMenuItem: {
		minHeight: '32px !important',
		display: 'flex',
		alignItems: 'center',
		paddingLeft: '8px',
		height: '32px',
		width: '220px',
		fontSize: FONT_SIZE_12PX,
		'& span': {
			fontSize: FONT_SIZE_12PX,
			textWrap: 'nowrap',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden'
		}
	},
	checkboxItemsContainer: {},

	subMenuItemCheckBox: {
		padding: 0,
		marginRight: '8px',
		transform: 'scale(0.8)'
	},

	/* Widget Footer Panel - element Styles/ Classes */
	vhWidgetFooter: {
		display: 'flex',
		flexDirection: 'column'
	},
	vhActionBtn: {
		borderRadius: 100,
		padding: '6px 16px',
		'& span': {
			fontSize: FONT_SIZE_12PX,
			fontWeight: 700
		}
	},
	vhSecondaryBtn: {
		border: '1px solid #D5D6D8'
	},
	vhPrimaryBtn: {
		backgroundColor: '#6245B7',
		'&:hover': {
			backgroundColor: '#6245B7'
		},
		'& span': {
			color: WHITE
		}
	},
	vhWidgetInfo: {
		fontSize: 12,
		padding: '8px 16px'
	},
	vhWidgetAction: {
		padding: 12,
		display: 'flex'
	},
	vhActionRight: {
		marginLeft: 'auto',
		display: 'flex',
		gap: '8px'
	},

	/* common - Widget & Filter */

	borderTopLeft: { borderRadius: '8px 0px 0px 0px' },
	borderTopRight: { borderRadius: '0px 8px 0px 0px' },
	panelHeaderBackground: { backgroundColor: '#F8F8F8' },
	vhWidgetHeaderContainer: {
		fontSize: FONT_SIZE_12PX,
		padding: '8px 14px',
		color: '#74767C',
		fontWeight: 'bold'
	},
	clearAllBtn: {
		'& span': {
			fontWeight: 700,
			fontSize: FONT_SIZE_12PX,
			color: LIGHTER_BLACK
		},
		'&:hover': {
			backgroundColor: WHITE
		}
	},
	clearAllDisabledBtn: {
		'& span': {
			color: '#BABBBE'
		}
	},
	vhDisabledActionBtn: {
		backgroundColor: '#dadce0',
		'&:hover': {
			backgroundColor: '#dadce0'
		},
		'& span': {
			color: WHITE
		}
	},
	hover: {
		'&:hover': {
			backgroundColor: LIGHT_GRAY_SHADE
		}
	},
	arrowStyles: {
		fontSize: '12px',
		paddingBottom: '0px'
	}
}));

export default useStyles;
